import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select",
  "use": "icon-select-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-select\">\r\n    <title>Select</title>\r\n  \r\n        <path d=\"M15.4838086,13.0058906 L21,9.43665234 L3,3 L9.43658203,21 L13.0058906,15.4838086 L16.8701953,19.3481133 C17.5544414,20.0323594 18.663832,20.0323242 19.3481133,19.3481133 C20.0323242,18.6638672 20.0323242,17.5544766 19.3481133,16.8701953 L15.4838086,13.0058906 Z\" />\r\n    \r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol